import React from "react"
import { MdDelete } from "react-icons/md"
import { type Props } from "./_types"
const IconDelete: React.FC<Props> = ({ size = 15, color = "#fff", onclick }): React.ReactElement => {
  return <MdDelete size={size} style={{ cursor: "pointer" }} color={color} onClick={onclick} />
}

export default IconDelete
